package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_02_07_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes, who have just purchased their first bastion. Lord Fox shows the heroes a magical floor plan. The heroes now see the true bastion, taller and on a smaller plot of land than the mirage they thought they saw before. Lord Fox hands the floor plan and key to Annette. Lord Fox suggests that his housekeeper, Viktor, can suggest a full-time grounds keeper. The heroes ask Lord Fox about chartered ships, Fox recommends they talk to a half orc named Floktis, who they can find at the Severed Serpent on the North side of the city. The heroes plan to meet with Fox at 7pm.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes Wind Walk to the Severed Serpent inn. The inn appears to cater to dock workers and other middle to lower class patrons — far less fancy than the Leaping Ram. The heroes discuss the idea of sailing North with Floktis; he needs an hour to pursue leads, so Caper and Tuesday decide to go shopping. Caper wants to play pirate, so she buys a peacoat and a bicorne hat. Tuesday aims to improve his famous hat with a strap.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Floktis returns. He offers passage on captain Leah L’Seth’s ship “the Cloud Chaser” for 900 gold, which sets sail at noon tomorrow (Shimmer 11). Dirk successfully haggles — the heroes pay 750 gold.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes travel to the Wharf Side Wicket Inn and ask Prudence for an update on the Verudis Pent investigation:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("A deeper investigation will take one week and cost 250 gold (100 gold now, 150 gold for the report).")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("For security reasons, the report must be picked up in person at the Wharf Side Wicket Inn.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("He left Dorvid recently. Nobody knows where he is but possibly at home in Pentish.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("He is a wizard, gifted in divination magic.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("He travels with a personal guard, who has a “smokey” aura.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette pays the 100 gold. The heroes brainstorm about the “smokey” aura:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Darkness spell")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The ability to travel through water or stone")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Demons emit auras of Darkness")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Nothing the heroes think of sounds exactly right. Perhaps it is something they are unaware of.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes return to the bastion. Bigglesworth investigates the barracks. He finds stairs leading down but the basement is partially collapsed. Korvis helps clear the way by shaping stone. Bigglesworth spots a chest and excitedly digs and digs. He reaches the chest but it contains nothing of interest.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" The bastion floor plan reveals that on the 4th floor, there are living chambers for two ladies and a single lord. The heroes conclude that the lord has two wives.")
        }
    }
}
